export const initialExternal = {
    isFetchingData: false,
    isAuthenticatedToView: true,
    isAuthorisedToView: true,
    isTokenTimeValid: true,
    isErrorView: false,
    isUnderMaintenanceView: false,
    underMaintenanceMessage: ""
};
